"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordBonus = void 0;
const constants_1 = require("@scrabble-solver/constants");
const Bonus_1 = require("./Bonus");
class WordBonus extends Bonus_1.Bonus {
    constructor() {
        super(...arguments);
        this.type = constants_1.BONUS_WORD;
    }
    get value() {
        return {
            characterMultiplier: 1,
            wordMultiplier: this.multiplier,
        };
    }
}
exports.WordBonus = WordBonus;
